import { useEffect, useMemo, useRef } from 'react';
import { useDataApi } from '@adsk/alloy-helpers';
import {
  buildGetUserSubscriptionsRequest,
  getSubscriptionMessages,
} from '../utils';

const useUserSubscriptions = ({
  accountId,
  classifiedOfferings,
  saved,
  userId,
  userName,
}) => {
  const {
    data: userSubscriptionsData,
    doFetch: doFetchUserSubscriptionsData,
    error: userSubscriptionsError,
    setData: setUserSubscriptionsData,
  } = useDataApi();

  const lastTrialMessages = useRef(null);

  useEffect(() => {
    lastTrialMessages.current = null;
  }, [userId]);

  useEffect(() => {
    if (!userId || !accountId) return;
    setUserSubscriptionsData(null);

    doFetchUserSubscriptionsData(
      buildGetUserSubscriptionsRequest(accountId, userId)
    );
  }, [
    accountId,
    doFetchUserSubscriptionsData,
    setUserSubscriptionsData,
    userId,
  ]);

  const licensingTrialMessages = useMemo(() => {
    if (!userSubscriptionsData) return {};
    if (userSubscriptionsError) return {};

    const shouldUpdate = lastTrialMessages.current === null || saved;

    if (shouldUpdate) {
      lastTrialMessages.current = getSubscriptionMessages(
        classifiedOfferings,
        userSubscriptionsData.results,
        userName
      );
    }

    return lastTrialMessages.current;
  }, [
    classifiedOfferings,

    saved,
    userName,
    userSubscriptionsData,
    userSubscriptionsError,
  ]);

  return {
    licensingTrialMessages,
  };
};

export default useUserSubscriptions;
